import {
	type NetworkTraceInfo,
	normaliseTraceInfo,
} from '@atlassian/search-client/network-trace-info';
import { type NetworkCallbacks } from '@atlassian/search-client/persist-refresh';

import type { TASK_NAMES } from './events/task-names';
import { onTaskFail, onTaskStart, onTaskSuccess } from './events/vital-stats-events';

type TaskNameValue = (typeof TASK_NAMES)[keyof typeof TASK_NAMES];

export type NetworkCallbackContext = {
	uxTaskId: string;
	isPreQuery?: boolean;
};

/**
 * Creates network callbacks for tracking network requests with VitalStats analytics.
 */
export const createVitalStatsNetworkCallbacks = (
	taskId: string,
	taskName: TaskNameValue,
	searchSessionId: string,
	fireAnalyticsEvent: (event: any) => void,
	configNetworkTaskStartAt: number,
	context: NetworkCallbackContext,
): NetworkCallbacks => {
	const baseParams = { taskId, task: taskName, searchSessionId };

	return {
		onStart: () => {
			fireAnalyticsEvent(onTaskStart({ ...baseParams, moreContext: context }));
		},
		onSuccess: (traceInfo?: NetworkTraceInfo) => {
			const timeTaken = performance.now() - configNetworkTaskStartAt;
			const tracingHeaders = normaliseTraceInfo(traceInfo);
			fireAnalyticsEvent(
				onTaskSuccess({
					...baseParams,
					moreContext: { ...context, timeTaken, ...tracingHeaders },
				}),
			);
		},
		onError: (errorName: string, errorMessage: string, traceInfo?: NetworkTraceInfo) => {
			const timeTaken = performance.now() - configNetworkTaskStartAt;
			const tracingHeaders = normaliseTraceInfo(traceInfo);
			fireAnalyticsEvent(
				onTaskFail({
					...baseParams,
					moreContext: {
						...context,
						errorName,
						errorMessage,
						timeTaken,
						...tracingHeaders,
					},
				}),
			);
		},
	};
};
